import styled from 'styled-components';

import Bg from '../../../images/solutions/process-bg.png';

export const ProcessStyled = styled.div`
  position: relative;
  margin: 90px 0;
  max-height: 1200px;
`;

export const DiagonalGray = styled.div`
  background: var(--lgray);
  clip-path: polygon(0 0%, 100% 6%, 100% 100%, -90% 90%);
  width: 100%;
  position: relative;
  padding-bottom: 980px;
  @media (min-width: 992px) {
    padding-bottom: 840px;
  }
  @media (min-width: 1024px) {
    padding-bottom: 1200px;
  }
`;

export const DiagonalBlue = styled.div`
  background: url(${Bg});
  background-repeat: no-repeat;
  background-position: 50% 194%;
  background-size: 280%;
  background-color: var(--dblue);
  width: 100%;
  height: 1250px;
  position: absolute;
  top: 0;
  z-index: 1;
  clip-path: polygon(0 5%, 100% 0, 100% 75%, 0 78.5%);
  .container {
    .mobile {
      margin-top: 120px;
      @media (min-width: 1024px) {
        display: none;
      }
    }
    .desktop {
      display: none;
      justify-content: space-between;
      padding: 0 20px;
      visibility: visible;
      transition: visibility 3s ease-in;
      &.hide {
        visibility: hidden;
        transition: visibility 3s ease-in;
      }
      @media (min-width: 1024px) {
        display: flex;
        position: relative;
        > img {
          position: absolute;
          width: 100%;
          position: absolute;
          width: 1300px;
          left: -38.5%;
          top: -15%;
          z-index: -1;
        }
      }
      @media (min-width: 1200px) {
        > img {
          left: -34%;
          top: -21%;
        }
      }
    }
  }
  @media (min-width: 393px) {
    background-position: 50% 225%;
  }
  @media (min-width: 410px) {
    background-position: 50% 335%;
  }
  @media (min-width: 414px) {
    background-position: 50% 350%;
  }
  @media (min-width: 425px) {
    background-position: 50% 520%;
  }
  @media (min-width: 480px) {
    background-position: 50% -240%;
  }
  @media (min-width: 768px) {
    background-size: 156%;
  }
  @media (min-width: 992px) {
    background-size: 109%;
    height: 1121px;
    clip-path: polygon(0 5%, 100% 0, 100% 70%, 0 75%);
  }
  @media (min-width: 1024px) {
    padding-top: 130px;
    height: 1490px;
    background-image: none;
  }
  @media (min-width: 1366px) {
    height: 1121px;
    padding-bottom: 350px;
    padding-top: 200px;
  }
  @media (min-width: 1440px) {
    padding-top: 140px;
  }
`;

export const WhiteBtn = styled.div`
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 56px;
  width: 155px;
  border-radius: 10px;
  background-color: var(--white);
  box-shadow: 0 10px 25px 0 rgba(4, 30, 66, 0.75);
  color: var(--black);
  font-family: Rubik;
  font-size: 12px;
  line-height: 16px;
  font-weight: bold;
  text-transform: uppercase;
  padding: 13px;
  position: absolute;
  top: 0;
  > img {
    height: 24px;
    width: 24px;
    padding-right: 5px;
  }
  &:nth-of-type(1) {
    left: 5%;
  }
  &:nth-of-type(2) {
    right: 5%;
  }
  @media (min-width: 768px) {
    padding: 15px;
    &:nth-of-type(1) {
      left: 15%;
    }
    &:nth-of-type(2) {
      right: 15%;
    }
  }
  @media (min-width: 992px) {
    width: 168px;
  }
`;

export const InnerBgText = styled.div`
  color: var(--white);
  font-family: Rubik;
  font-size: 16px;
  font-weight: bold;
  text-transform: uppercase;
  text-align: center;
  position: absolute;
  top: 28%;
  width: 150px;
  text-align: center;
  margin: 0 auto;
  width: 100%;
`;

export const BlueBtn = styled.div`
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 56px;
  width: 155px;
  border-radius: 10px;
  background-color: var(--blue);
  box-shadow: 0 10px 25px 0 rgba(4, 30, 66, 0.75);
  color: var(--white);
  font-family: Rubik;
  font-size: 16px;
  line-height: 24px;
  font-weight: bold;
  text-transform: uppercase;
  padding: 15px;
  position: absolute;
  bottom: 0;
  left: 0;
  @media (min-width: 992px) {
    width: 168px;
  }
`;

export const BlueBtnRight = styled.div`
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 56px;
  width: 155px;
  border-radius: 10px;
  background-color: var(--blue);
  box-shadow: 0 10px 25px 0 rgba(4, 30, 66, 0.75);
  color: var(--white);
  font-family: Rubik;
  font-size: 16px;
  line-height: 24px;
  font-weight: bold;
  text-transform: uppercase;
  padding: 15px;
  position: absolute;
  bottom: 0;
  right: 0;
  @media (min-width: 992px) {
    width: 168px;
  }
`;

export const ColumnLeft = styled.div`
  padding-top: 90px;
  position: relative;
  &.hide {
    visibility: hidden;
  }
  @media (min-width: 992px) {
    width: 523px;
    padding-top: 0;
  }
`;

export const ButtonContainer = styled.div`
  position: relative;
  height: 450px;
  width: 100%;
  top: 100px;
  left: 0;
  ${BlueBtn} {
    &:nth-of-type(1) {
      left: 0;
    }
    &:nth-of-type(2) {
      right: 0;
    }
  }

  @media (min-width: 393px) {
    top: 40px;
  }
  @media (min-width: 425px) {
    top: 50px;
  }
  @media (min-width: 480px) {
    top: 0;
  }
  @media (min-width: 768px) {
    margin: 0 auto;
    width: 70%;
  }
  @media (min-width: 1024px) {
    height: 440px;
    width: 504px;
    top: 20%;
  }
`;

export const Subtitle = styled.p`
  color: var(--gray);
  font-family: Rubik;
  font-size: 16px;
  letter-spacing: 0;
  line-height: 24px;
  text-transform: uppercase;
  padding: 0 20px;
  @media (min-width: 992px) {
    padding: 0;
  }
`;

export const Title = styled.h1`
  color: var(--white);
  font-family: Rubik;
  font-size: 32px;
  font-weight: bold;
  letter-spacing: 0;
  line-height: 40px;
  margin-top: 10px;
  padding: 0 20px;
  @media (min-width: 992px) {
    padding: 0;
  }
`;

export const ColumnRight = styled.div`
  width: 456px;
  height: 711px;
  position: relative;
  top: 235px;
  &:before {
    content: '';
    height: 100%;
    width: 2px;
    position: absolute;
    top: -250px;
    left: 35px;
    z-index: -1;
    background: linear-gradient(rgba(29, 66, 138, 0), rgba(29, 66, 138, 1));
  }
  &:after {
    content: '';
    height: 100%;
    width: 2px;
    position: absolute;
    bottom: -20px;
    left: 35px;
    z-index: -1;
    background: linear-gradient(rgba(29, 66, 138, 1), rgba(29, 66, 138, 0));
  }
  &.hide {
    visibility: hidden;
  }
  @media (min-width: 1200px) {
    top: 220px;
  }
`;

export const BulletPlace = styled.div`
  height: 72px;
  width: 72px;
  margin-right: 24px;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  cursor: pointer;
`;

export const ImgCont = styled.div`
  box-sizing: border-box;
  height: 72px;
  width: 72px;
  display: none;
  justify-content: center;
  align-items: center;
  border-radius: 16px;
  background-color: var(--white);
  box-shadow: 0 0 50px 0 rgba(0, 0, 0, 0.1);
  padding: 16px;
`;

export const DotCont = styled.div`
  height: 16px;
  width: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  transform: translate(15px, -15px);
  img {
    &:last-of-type {
      display: none;
    }
  }
  &:hover {
    img:first-of-type {
      display: none;
    }
    img:last-of-type {
      display: inline;
    }
  }
  @media (min-width: 992px) {
    transform: translateY(-27px);
    height: 72px;
    width: 72px;
  }
`;

export const TextCont = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  width: 100%;
  min-height: 179px;
  h6 {
    font-family: Rubik;
    font-size: 24px;
    line-height: 32px;
    color: var(--white);
    margin-top: -7px;
    cursor: pointer;
  }
  p {
    display: none;
    font-family: Rubik;
    font-size: 16px;
    line-height: 24px;
    color: var(--gray);
    margin-top: 10px;
  }
  @media (min-width: 992px) {
    min-height: unset;
  }
`;

export const ProcessCard = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 48px;
  height: 16px;
  &.active-process {
    display: flex;
    height: 152px;
    ${DotCont} {
      display: none;
    }
    ${ImgCont} {
      display: flex;
    }
    ${TextCont} {
      p {
        display: block;
      }
    }
  }
`;

//Mobile bullet container
export const BulletContainer = styled.div<{ currentProcess: number }>`
  overflow-x: scroll;
  overflow-y: none;
  width: 100vw;
  margin-top: 55px;
  position: relative;
  scroll-behavior: smooth;
  .inner {
    display: flex;
    align-items: baseline;
    justify-content: space-between;
    width: 650px;
    scroll-behavior: smooth;
    @media (min-width: 768px) {
      width: auto;
    }
  }

  ${ProcessCard} {
    height: unset;
    margin-bottom: 0;
    margin-right: 40px;
    width: 72px;
    ${BulletPlace} {
      width: 16px;
    }
    &.active-process {
      ${BulletPlace} {
        width: 72px;
      }
      ${DotCont} {
        display: none;
      }
      ${ImgCont} {
        display: flex;
      }
    }
    &:first-of-type {
      margin-left: 44px;
    }
    &:last-of-type {
      margin-right: 44px;
    }
  }
  &:before {
    content: '';
    position: absolute;
    top: 32px;
    height: 2px;
    width: 200vw;
    z-index: -1;
    background: linear-gradient(
      rgba(29, 66, 138, 0),
      rgba(29, 66, 138, 1),
      rgba(29, 66, 138, 1),
      rgba(29, 66, 138, 0)
    );
    left: 0;
    right: 0;
    @media (min-width: 414px) {
      width: 160vw;
    }
    @media (min-width: 768px) {
      /* top: -352px; */
    }
  }
  &::-webkit-scrollbar {
    display: none;
  }
  & {
    -ms-overflow-style: none;
  }
`;

// Mobile text process card
export const TextContainer = styled.div`
  padding: 0 20px;
  margin-top: 28px;
  ${ProcessCard} {
    margin-bottom: unset;
    height: unset;
    ${TextCont} {
      display: none;
    }
    &.active-process {
      ${TextCont} {
        display: flex;
      }
    }
  }
`;
